/**
 * Decides whether Sentry should be enabled from the raw
 * `VITE_SENTRY_ENABLED` env value and whether this is a `vite serve` (dev)
 * build. Extracted from `constants.ts` so the branch is unit-testable:
 * `constants.ts` reads `import.meta.env`, which Jest can't parse.
 */
export const resolveSentryEnabled = (
  value: string | undefined,
  isDev: boolean
): boolean => {
  if (value === 'true') return true
  if (value === 'false') return false

  return !isDev
}
